import { createShapeId, toRichText } from 'tldraw';
import { artifactToCanvasText } from './boardChatArtifacts';
import { extractBoardDocumentSnapshot } from './boardSnapshot';
import { flushBoardDocumentOps } from './persistBoardDocumentOps';

/**
 * Place a chat artifact on the canvas as a text shape near the viewport.
 * Explicit user action only (place_on_canvas) — never auto from chat response.
 */
export function placeChatArtifactOnCanvas(editor, artifact, { saveSnapshot } = {}) {
  if (!editor || !artifact) return null;
  const content = artifactToCanvasText(artifact).trim();
  if (!content) return null;

  const viewport = editor.getViewportPageBounds?.();
  const x = (viewport?.x || 0) + Math.max(40, (viewport?.w || 900) * 0.08);
  const y = (viewport?.y || 0) + 60;
  const w = Math.min(520, Math.max(280, (viewport?.w || 900) * 0.35));

  const slug = String(artifact.title || artifact.kind || 'artifact')
    .replace(/[^\w\-]+/g, '-')
    .slice(0, 40);
  const shapeId = createShapeId(`chat-artifact-${slug}-${Date.now()}`);
  const before = extractBoardDocumentSnapshot(editor);

  editor.markHistoryStoppingPoint?.('before-place-chat-artifact');
  editor.createShape({
    id: shapeId,
    type: 'text',
    x,
    y,
    props: {
      color: 'black',
      size: 's',
      w,
      font: 'sans',
      textAlign: 'start',
      autoSize: false,
      scale: 1,
      richText: toRichText(content),
    },
    meta: {
      aiGenerated: true,
      chatArtifactKind: artifact.kind,
      chatArtifactTitle: String(artifact.title || '').slice(0, 160),
    },
  });

  try {
    editor.select(shapeId);
    editor.zoomToSelection?.({ animation: { duration: 200 } });
  } catch {
    // ignore camera helpers
  }

  try {
    if (typeof saveSnapshot === 'function') {
      // Ops-only saver when wired from TldrawBoard / chat launcher.
      saveSnapshot(extractBoardDocumentSnapshot(editor));
    } else {
      void flushBoardDocumentOps(editor, before);
    }
  } catch {
    // ignore persist errors
  }

  return shapeId;
}
